import { Button } from '#app/components/ui/button.tsx'

export default function Page() {
	return (
		<main className="container">
			<section className="ml-2 mt-4">
				<h1 className="py-2  text-2xl font-light leading-[100%] text-[#232323]">
					成長支援シート（育成計画書）イメージ
				</h1>
			</section>
			<section className="overflow-x-auto">
				<div className="flex">
					<img
						src="/img/growth-support-sheet-sample.png"
						alt="growth-support-sheet-sample"
					/>
				</div>
			</section>
			<section className="mt-8">
				<div className="flex justify-center">
					<Button
						variant={'outline'}
						className="bg-white font-semibold"
						onClick={() => {
							window.close()
						}}
					>
						閉じる
					</Button>
				</div>
			</section>
		</main>
	)
}
